import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Loading from 'components/Loading';
import api from 'api';
import FoodSearch from 'components/FoodSearch';
import Util from 'utility';

function LectureTaskPanelAddFood({ isDrinkRegime, mealId, groupId }) {
    const data = useSelector(state => state);
    const [foodLoading, setFoodLoading] = useState(false);
    const [currentFood, setCurrentFood] = useState(null);

    const showFoodDetail = (id) => {
        setFoodLoading(true);
        api('foods/detail/' + id).then(result => {
            setFoodLoading(false);
            setCurrentFood(result.data);
        });
    };

    const closeFoodDetail = () => {
        setFoodLoading(false);
        setCurrentFood(null);
    };

    let content;
    if(foodLoading) {
        content = <Loading />;
    } else if(currentFood) {
        const food = currentFood;
        let undesirableInfo = null;
        if(!Util.isNutriKucharMode(data.appMode) && data.appModeData?.undesirableFoods?.includes(food.id)) {
            undesirableInfo = <p className="flex text-[0.85em] mt-[2px] text-[#f00] [&>span]:text-[0.85em] [&>span]:mr-[0.5em] [&>span]:font-bold [&>span]:uppercase"><span>Nevhodná potravina</span></p>;
        }
        content = (
            <div>
                <a className="inline-flex items-center gap-[0.4em] text-[0.85em] text-[#555] cursor-pointer hover:text-black mb-[0.5em]" onClick={closeFoodDetail}>
                    <i className="fa fa-angle-left"></i> Zpět
                </a>
                <div className="flex items-center my-[1em] gap-[1.5rem]">
                    <img className="w-[60px] h-auto shrink-0" src={`https://www.zofapp.cz/data/zof/item/${food.id}.svg`} alt="" />
                    <h1 className="text-[1.8em] font-bold m-0">{food.title}</h1>
                </div>
                {undesirableInfo}
                <div dangerouslySetInnerHTML={{__html: food.description}} />
            </div>
        );
    } else {
        content = <FoodSearch onClick={showFoodDetail} isEmbedded={true} isDrinkRegime={isDrinkRegime} mealId={mealId} groupId={groupId} />;
    }

    return (
        <div className="flex flex-col flex-1">{content}</div>
    );
}

export default LectureTaskPanelAddFood;
